export const LARGE_INPUT_HEIGHT = 56;
export const MEDIUM_INPUT_HEIGHT = 44;
export const SMALL_INPUT_HEIGHT = 36;
export const EXTRA_SMALL_INPUT_HEIGHT = 30;

export const DEFAULT_DATA_GRID_MOBILE_PAGE_SIZE = 10;
